import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
  minutesAgo: number;
}
export function SocialProofPopup() {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const purchases: Purchase[] = [{
    name: 'María',
    location: 'Buenos Aires, Argentina',
    minutesAgo: 3
  }, {
    name: 'Carlos',
    location: 'CDMX, México',
    minutesAgo: 5
  }, {
    name: 'Laura',
    location: 'Madrid, España',
    minutesAgo: 7
  }, {
    name: 'Diego',
    location: 'Santiago, Chile',
    minutesAgo: 2
  }, {
    name: 'Ana',
    location: 'Bogotá, Colombia',
    minutesAgo: 4
  }, {
    name: 'Javier',
    location: 'Lima, Perú',
    minutesAgo: 6
  }, {
    name: 'Sofía',
    location: 'Montevideo, Uruguay',
    minutesAgo: 8
  }, {
    name: 'Miguel',
    location: 'Caracas, Venezuela',
    minutesAgo: 3
  }, {
    name: 'Valentina',
    location: 'Quito, Ecuador',
    minutesAgo: 5
  }, {
    name: 'Andrés',
    location: 'San José, Costa Rica',
    minutesAgo: 4
  }];
  useEffect(() => {
    const showNotification = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const interval = setInterval(showNotification, 10000);
    showNotification();
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-125">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl p-4 max-w-sm" data-id="element-126">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-127">
            <XIcon className="w-4 h-4" data-id="element-128" />
          </button>

          <div className="flex items-center gap-3" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/8oir4cejC94Ra5gXcAVHun/ChatGPT_Image_5_may_2026,_01_57_43_a.m..png" alt="Producto" className="w-12 h-12 rounded" data-id="element-130" />
            <div data-id="element-131">
              <p className="font-bold text-sm" data-id="element-132">
                {currentPurchase.name} de {currentPurchase.location}
              </p>
              <p className="text-xs text-gray-600" data-id="element-133">acaba de comprar</p>
              <p className="text-xs text-gray-500" data-id="element-134">
                hace {currentPurchase.minutesAgo} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}